import { LedgerItemType } from 'further-types/cash-movement';

export const CashBalanceItemTypeToLabelMap = {
  [LedgerItemType.InvestmentResidualCash]: 'Residual cash',
  [LedgerItemType.InvestmentFrozenCash]: 'Residual cash',
  [LedgerItemType.InvestmentResidualCashReversal]: 'Residual cash return',
  [LedgerItemType.Exit]: 'Exit',
  [LedgerItemType.ExitAmendment]: 'Exit Amendment',
  [LedgerItemType.Withdrawal]: 'Withdrawal',
  [LedgerItemType.RejectedWithdrawal]: 'Cancelled withdrawal',
  [LedgerItemType.RejectedWithdrawalFee]: 'Cancelled withdrawal fee',
  [LedgerItemType.NewInvestment]: 'Move to new investment',
  [LedgerItemType.Interest]: 'Interest',
  [LedgerItemType.InvestorFee]: 'Fee',
  [LedgerItemType.WithdrawalFee]: 'Withdrawal fee',
  [LedgerItemType.Dividend]: 'Dividend',
  [LedgerItemType.ManualAdjustment]: 'Manual adjustment',
  [LedgerItemType.Transfer]: 'Transfer',
  [LedgerItemType.InvestorDiscount]: 'Discount',
};
